
import { supabase } from '@/integrations/supabase/client';
import { handleError } from './utils';

export async function deleteTemplate(id: string): Promise<void> {
  try {
    // First get all steps to delete related data
    const { data: steps } = await supabase
      .from('steps')
      .select('id')
      .eq('roadmap_id', id);
      
    if (steps && steps.length > 0) {
      for (const step of steps) {
        // Delete links
        await supabase.from('links').delete().eq('step_id', step.id);
        
        // Get prompt module to delete related data
        const { data: promptModule } = await supabase
          .from('prompt_modules')
          .select('id')
          .eq('step_id', step.id)
          .single();
          
        if (promptModule) {
          // Delete fields and instructions
          await supabase.from('prompt_fields').delete().eq('prompt_module_id', promptModule.id);
          await supabase.from('prompt_instructions').delete().eq('prompt_module_id', promptModule.id);
          // Delete module
          await supabase.from('prompt_modules').delete().eq('id', promptModule.id);
        }
      }
      
      // Delete all steps
      await supabase.from('steps').delete().eq('roadmap_id', id);
    }
    
    // Get sidebar to delete related data
    const { data: sidebar } = await supabase
      .from('sidebars')
      .select('id')
      .eq('roadmap_id', id)
      .single();
      
    if (sidebar) {
      // Delete tools, activities, and examples
      await supabase.from('sidebar_tools').delete().eq('sidebar_id', sidebar.id);
      await supabase.from('sidebar_activities').delete().eq('sidebar_id', sidebar.id);
      await supabase.from('sidebar_examples').delete().eq('sidebar_id', sidebar.id);
      // Delete sidebar
      await supabase.from('sidebars').delete().eq('id', sidebar.id);
    }
    
    // Finally delete the roadmap template
    await supabase.from('roadmap_templates').delete().eq('id', id);
  } catch (error) {
    handleError(error, 'Error deleting template');
  }
}
